<template>
	<div id="centerWidth" :style="{'height':windowHeight+'px'}" style="overflow: auto;" @scroll="scrollEvent($event)">
		<div class="centerWidth">
			<div class="gaokao-nav">
				<span @click="goMyCenter">个人中心 ></span>
				<span>查.大学排名</span>
			</div>
			<section class="gaokao-content">
				<article class="fenNum_head flex zhong center xieqDiv">
					<p :class="isTab == 0 ? 'on' : ''" @click="tabClick(0)">
						<i></i>
						<span>ESI全球学科排行榜</span>
					</p>
					<p :class="isTab == 1 ? 'on' : ''" @click="tabClick(1)">
						<i></i>
						<span>武书连榜单</span>
					</p>
					<p :class="isTab == 2 ? 'on' : ''" @click="tabClick(2)">
						<i></i>
						<span>校友会榜单</span>
					</p>
				</article>
				<!--  -->
				<div style="overflow: hidden;" v-if="isTab == 0">
					<div class="my-title">ESI全球学科排行榜</div>
					<article class="table">
						<hgroup class="flex">
							<p>名次</p>
							<p>院校名称</p>
							<p>所在地</p>
							<p>世界前1%学科数</p>
							<p>世界排名</p>
							<p>SCI论文</p>
						</hgroup>
						<ul>
							<li class="flex" v-for="(item, index) in tableList" :key="index">
								<p>{{ item.Ranking }}</p>
								<p>{{ item.CollegesName }}</p>
								<p>{{ item.CollegesArea }}</p>
								<p>{{ item.Subjects }}</p>
								<p>{{ item.WorldRankings }}</p>
								<p>{{ item.SCIPapers }}</p>
							</li>
						</ul>
					</article>
				</div>

				<div style="overflow: hidden;" v-else-if="isTab == 1">
					<div class="my-title">武书连榜单</div>
					<article class="table martialTop">
						<hgroup class="flex">
							<p>排序</p>
							<p>院校名称</p>
							<p>总分</p>
							<p>人才培养</p>
							<p>科学研究</p>
							<p>类型</p>
							<p>所在地</p>
						</hgroup>
						<ul>
							<li class="flex" v-for="(item, index) in martialList" :key="index">
								<p>{{ item.Sort }}</p>
								<p>{{ item.CollegesName }}</p>
								<p>{{ item.TotalScore }}</p>
								<p>{{ item.Training }}</p>
								<p>{{ item.Research }}</p>
								<p>{{ item.TypeStr }}</p>
								<p>{{ item.CollegesArea }}</p>
							</li>
						</ul>
					</article>
				</div>

				<div style="overflow: hidden;" v-else-if="isTab == 2">
					<div class="my-title ">校友会榜单</div>
					<article class="table xiaoDiv">
						<hgroup class="flex">
							<p>排序</p>
							<p>院校名称</p>
							<p>总分</p>
							<p>类型</p>
							<p>所在地</p>
						</hgroup>
						<ul>
							<li class="flex" v-for="(item, index) in xiaoList" :key="index">
								<p>{{ item.Sort }}</p>
								<p>{{ item.CollegesName }}</p>
								<p>{{ item.TotalScore }}</p>
								<p>{{ item.TypeStr }}</p>
								<p>{{ item.CollegesArea }}</p>
							</li>
						</ul>
					</article>
				</div>

				<!-- <div class="flex xend major-page">
					<el-pagination background layout="prev, pager, next" :page-size="size" @current-change="GetPageList"
						:current-page="page" :total="totleNum"></el-pagination>
				</div> -->
			</section>

		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				isTab: 0,
				page: 1,
				size: 10,
				totleNum: 0,
				tableList: [],
				martialList: [],
				xiaoList: [],
				windowHeight: document.documentElement.clientHeight
			};
		},
		// 加载
		created() {
			this.GetESIGlobalByPage(1);
			if (this.$route.query.key) {
				this.$api.reduceUserCount({
					key: this.$route.query.key
				});
			} else {
				this.$router.back(-1);
			}
		},
		watch: {
			windowHeight(val) {
				const that = this;
				console.log('实时屏幕高度：', val, that.windowHeight);
			}
		},
		mounted() {
			const that = this;
			window.onresize = () => {
				return (() => {
					window.fullHeight = document.documentElement.clientHeight;
					that.windowHeight = window.fullHeight;
				})();
			};
		},
		methods: {
			scrollEvent(e) {
				var that = this;
				var scrollBottom = e.target.scrollHeight - e.target.scrollTop - e.target.clientHeight;
				// console.log('滚动', scrollBottom);
				if (scrollBottom < 10) {
					if (that.isPage) {
						// console.log('翻页');
						that.isPage = false;
						var pg = that.page + 1;
						that.GetPageList(pg);
					}
				}
			},
			// 个人中心
			goMyCenter() {
				this.$router.push('/myIndex');
			},

			// 获取列表
			GetESIGlobalByPage: function(page) {
				var that = this;

				that.$api.HtppRequest(
					'SystemData/GetESIGlobalByPage?page=' + page + '&size=10',
					'GET', {},
					function(res) {
						// console.log('获取列表',res);
						
						if(page==1){
							that.list =[];
						}
						if (res.flag) {
							if (res.list.length > 0) {
								that.tableList = that.tableList.concat(res.list);
								that.page = page;
								// console.log(that.tableList);
							}
							that.isPage = true;
							that.totleNum = res.totalCount;
						}
						that.BLoading = false;
						that.isNoData = that.tableList.length==0;
					},
					function(err) {
						console.log(err);
					}
				);
			},
			// 获取列表
			GetMartialArtsByPage: function(page) {
				var that = this;

				that.$api.HtppRequest(
					'SystemData/GetMartialArtsByPage?page=' + page + '&size=10',
					'GET', {},
					function(res) {
						// console.log('获取列表');
						// console.log(res);
						if(page==1){
							that.martialList =[];
						}
						if (res.flag) {
							if (res.list.length > 0) {
								that.martialList = that.martialList.concat(res.list);
								that.page = page;
								// console.log(that.martialList);
							}
							that.isPage = true;
							that.totleNum = res.totalCount;
						}
						that.BLoading = false;
						that.isNoData = that.martialList.length==0;
					},
					function(err) {
						console.log(err);
					}
				);
			},
			// 获取列表
			GetAlumniAssociationByPage: function(page) {
				var that = this;

				that.$api.HtppRequest(
					'SystemData/GetAlumniAssociationByPage?page=' + page + '&size=10',
					'GET', {},
					function(res) {
						// console.log('获取列表');
						// console.log(res);
						if(page==1){
							that.xiaoList =[];
						}
						if (res.flag) {
							if (res.list.length > 0) {
								that.xiaoList = that.xiaoList.concat(res.list);
								that.page = page;
								// console.log(that.xiaoList);
							}
							that.isPage = true;
							that.totleNum = res.totalCount;
						}
						that.BLoading = false;
						that.isNoData = that.xiaoList.length==0;
					},
					function(err) {
						console.log(err);
					}
				);
			},
			// 获取其他页
			GetPageList: function(val) {
				var that = this;
				if (that.isTab === 0) {
					that.GetESIGlobalByPage(val);
				}
				if (that.isTab === 1) {
					that.GetMartialArtsByPage(val);
				}
				if (that.isTab === 2) {
					that.GetAlumniAssociationByPage(val);
				}
			},
			tabClick(index) {
				var that = this;

				if (that.isTab !== index) {
					that.isTab = index;
					that.page = 1;
					if (that.isTab === 0) {
						that.GetESIGlobalByPage(1);
					}
					if (that.isTab === 1) {
						that.GetMartialArtsByPage(1);
					}
					if (that.isTab === 2) {
						that.GetAlumniAssociationByPage(1);
					}
				}
			}
		}
	};
</script>

<style scoped>
	.xiaoDiv li p {
		width: 20% !important;
	}

	.xiaoDiv hgroup p {
		width: 20% !important;
	}

	.table li p {
		font-size: 14px;
		width: calc(100% / 6);
		line-height: 60px;
		text-align: center;
	}

	.table li:last-child {
		border-bottom: none;
	}

	.table li p:last-child {
		border-right: none;
	}

	.table li {
		border-bottom: solid 1px #e6e6e6;
	}

	.table ul {
		overflow: hidden;
	}

	.table hgroup p {
		font-size: 14px;
		background-color: #eaeaea;
		width: calc(100% / 6);
		line-height: 60px;
		text-align: center;
	}

	.table {
		overflow: hidden;
		border: solid 1px #e6e6e6;
		box-sizing: border-box;
		margin-top: 30px;
	}

	/* 01 */
	.fenNum_div p {
		width: 78px;
		height: 40px;
		line-height: 40px;
		float: left;
		color: #333;
		font-size: 14px;
		margin-right: 20px;
		text-align: center;
		border-radius: 4px;
		cursor: pointer;
	}

	.fenNum_div p:hover {
		opacity: 0.7;
	}

	.fenNum_div p.on:hover {
		opacity: 1;
	}

	.fenNum_div p.on {
		background-color: #333;
		color: #fff;
	}

	.fenNum_div {
		width: calc(100% - 200px);
		margin-left: 20px;
	}

	.major-share label {
		font-size: 14px;
		color: #333;
		display: block;
		width: 100px;
		line-height: 40px;
		text-align: right;
	}

	.major-share ul li:first-child {
		margin-top: 0;
	}

	.major-share ul li {
		margin-top: 10px;
	}

	.major-share ul {
		overflow: hidden;
	}

	/* major-share */

	.gaokao-btn {
		width: 90px;
		font-size: 14px;
		margin-left: 0 !important;
	}

	/* fenNum_head */

	.gaokao-nav {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 20px 0;
	}

	.gaokao-nav span {
		font-size: 15px;
		color: #333;
	}

	.gaokao-nav span:last-child {
		color: #333;
	}

	/* gaokao-content */
	.gaokao-content {
		padding: 0 20px;
		width: 100%;
		height: auto;
		overflow: hidden;
		background-color: #fff;
		margin-bottom: 25px;
		padding-bottom: 60px;
	}

	/* major-share */
	.major-share {
		width: 100%;
		height: auto;
		overflow: hidden;
		background-color: #eaeaea;
		margin: 20px auto 30px auto;
		padding: 30px 0;
	}

	.major-share-con {
		width: 75%;
		height: auto;
		overflow: ;
		display: flex;
		flex-wrap: wrap;
	}

	.share-li {
		width: 50%;
		display: flex;
		align-items: center;
		/* justify-content: center; */
		margin: 10px 0;
	}

	.share-li p {
		font-size: 14px;
		color: #333;
		width: 100px;
		text-align: right;
		margin-right: 20px;
	}

	.share-li input {
		width: 270px;
		height: 40px;
		line-height: 40px;
		padding: 0 10px;
		display: block;
		border-radius: 5px;
		background-color: #fff;
		color: #333;
		font-size: 14px;
	}

	.share-li input::-webkit-input-placeholder {
		color: #999;
	}

	.share-li input:-moz-placeholder {
		color: #999;
	}

	.share-li input:-ms-input-placeholder {
		color: #999;
	}

	.sjWidth {
		width: 270px;
	}

	.major-btn01 {
		width: 25%;
		display: flex;
		align-items: flex-end;
	}

	.major-btn01 button {
		margin: 10px auto;
	}

	/* major-list */
	.major-list {
		width: 100%;
		height: auto;
		margin-top: 15px;
	}

	.major-list ul {
		width: 100%;
		height: auto;
	}

	.major-list ul li {
		border: 1px solid #eee;
		width: 100%;
		height: auto;
		padding: 20px 30px;
		margin-bottom: 20px;
		position: relative;
	}

	.major-li01 {
		width: 100%;
		height: auto;
		display: flex;
		align-items: center;
	}

	.major-li-btn {
		width: 23%;
	}

	.major-li-btn p {
		width: 130px;
		height: 33px;
		line-height: 33px;
		text-align: center;
		background-color: #333;
		font-size: 16px;
		color: #fff;
		border-radius: 50px;
	}

	.major-li01-right {
		width: 80%;
		display: flex;
	}

	.major-li01-right p {
		width: 20%;
		display: flex;
		align-items: center;
		line-height: 33px;
	}

	.major-li01-right p span {
		font-size: 15px;
		color: #999;
	}

	.major-li01-right p span:last-child {
		color: #333;
	}

	.major-li02 {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
	}

	.major-li02 p {
		font-size: 14px;
	}

	.major-txt01 {
		width: 75px;
		color: #999;
	}

	.major-txt02 {
		width: calc(100% - 120px);
		color: #333;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.major-more {
		width: 45px;
		color: #333;
		text-align: right;
		cursor: pointer;
	}

	.major-txt04 {
		color: #333;
	}

	.major-more-con {
		position: absolute;
		width: 98%;
		height: auto;
		background: rgba(0, 0, 0, 0.7);
		padding: 20px;
		font-size: 15px;
		color: #fff;
		left: 1%;
		bottom: 0;
		border-radius: 5px;
		margin-bottom: -14px;
		z-index: 1;
	}

	.major-more-con::after {
		position: absolute;
		content: '';
		right: 0;
		top: 0;
		width: 0;
		height: 0;
		border-left: 8px solid transparent;
		border-right: 8px solid transparent;
		border-bottom: 14px solid rgba(0, 0, 0, 0.7);
		margin-top: -14px;
		margin-right: 24px;
	}

	.major-page {
		margin-bottom: 30px;
	}

	.widthx {
		margin-top: 20px;
		margin-bottom: 10px;
	}

	.widthx .major-li01-right {
		width: 100%;
	}

	.widthx .major-li01-right p:first-child {
		min-width: 22.2%;
	}

	.widthx .major-li01-right p:nth-child(2) {
		width: 32.3%;
	}

	.lastIndex .major-li01-right p {
		width: 35%;
	}

	.my-title::after {
		width: 0;
	}
</style>
